// Sistema di localizzazione per l'app
export const translations = {
  it: {
    // Hero section
    heroTitleOne: "L'infrastruttura digitale ",
    heroTitleTwo: "strategica per il Paese",
    heroTitleThree: "",
    
    // Breadcrumb
    home: "Home",
    marketspace: "Marketspace",
    
    // Common buttons and labels
    loading: "Caricamento...",
    error: "Errore",
    retry: "Riprova",
    
    // Address form
    addressTitle: "Verifica se il tuo indirizzo è coperto",
    addressPlaceholder: "Es. via Roma, 1 Varese",
    searchButton: "Verifica copertura",
    addressNotFound: "Indirizzo non trovato",
    selectAddress: "Seleziona un indirizzo",
    serviceUnavailable: "Servizio «Verifica di copertura» al momento non disponibile. Ci spiace.",
    tryAgainLater: "Riprova più tardi.",
    closePopup: "Chiudi popup",
    addressTooltip: "Per continuare, scegli prima uno degli indirizzi rilevati.",
    
    //LoadingTruck
    loadingTruckFirstLabel: "Stiamo verificando la copertura del tuo indirizzo,",
    loadingTruckSecondLabel: "ci vorrà solo un momento…",
    loadingPlaceholderTruck: "Caricamento in corso...",


    // Newsletter
    newsletterTitle: "Resta aggiornato",
    newsletterPlaceholder: "Lascia la tua email, resta sempre aggiornato",
    newsletterButton: "Iscriviti",
    comunePlaceholder: "Comune (facoltativo)",
    privacyText: "Ho letto la",
    privacyLink: "Policy privacy",
    newsletterSuccess: "La tua email è stata inserita correttamente, sarai notificato appena possibile.",
    newsletterError: "Errore nell'invio. Riprova più tardi.",
    privacyRequired: "Devi accettare la privacy policy prima di procedere.",
    

    // Pagination
    previous: "Indietro",
    next: "Avanti",
    anotherRequest: "Fai un'altra richiesta",

    // Disclaimer
    offersDisclaimer: "Le offerte pubblicate in questa sezione sono inserite, aggiornate e gestite in piena autonomia dagli operatori partner, che ne sono gli unici responsabili. FiberCop S.p.A. è un operatore wholesale e non vende direttamente servizi di connettività al consumatore finale. La tecnologia (FTTH o FTTCab) e le prestazioni effettive dipendono dalla copertura disponibile al singolo indirizzo.",


    // Results
    covered: "Coperto!",
    arriving: "In arrivo la rete ultraveloce",
    noCoverage: "Non ancora coperto",
    offersAvailable: "Offerte disponibili",


    //filters
    filterPrivate: "Privati",
    filters: "Aziende / PMI",
    filterVelocity: "Velocità",

    //Covered
    coveredCTA: "Naviga alla massima velocità con FTTH fino a 10Giga",
    fiberstreamFtthCTA: "Puoi anche navigare alla massima velocità in FTTH fino a 2,5 Giga",
    coveredSubTitle: "Non perdere le offerte degli operatori dedicate ai clienti privati e aziende",
    speedFilterTitle: "Velocità",

    //Arriving
    arrivingCTA: "Naviga in FTTCab fino a 200 mega con la migliore connessione FiberCop disponibile per te!",
    arrivingSubTitle: "Non perdere le offerte degli operatori dedicate ai clienti privati e aziende",
    buttonNotifyMe: "Avvisami quando disponibile",
        //MODAL - Arriving FTTH-FTTC
        titleModalArriving: "Lasciaci i tuoi contatti: ",
        titleModalArrivingTwo: "ti informeremo quando la rete ultraveloce FiberCop FTTH fino a 10 Giga raggiungerà il tuo indirizzo",
        titleModalArrivingTwoFTTC: "ti informeremo quando la rete ultraveloce FiberCop FTTCab fino a 200 mega raggiungerà il tuo indirizzo",
        modalArrivingName: "Nome",
        modalArrivingSurname: "Cognome",
        modalArrivingEmail: "Email",
        modalPrivacyCheckboxText: "Dichiaro di aver letto ",
        modalPrivacyCheckboxTextTwo: "l’informativa sulla privacy",
        modalPrivacyCheckboxTextThree: " e acconsento al trattamento dei miei Dati ",
        modalPrivacySubText: "A seguito della tua richiesta i tuoi dati saranno conservati per un periodo massimo di 12 mesi",
        modalSubmit: "Invia",

    
    //Uncovered ma fttc disponibile
    uncoveredCTA: "Naviga in FTTCab fino a 200 mega con la migliore connessione FiberCop disponibile per te!",
    uncoveredSubTitle: "Non perdere le offerte degli operatori dedicate ai clienti privati e aziende",
    uncoveredRequestInfo: "Facci sapere se sei interessato a navigare con la rete ultraveloce di FiberCop",
    uncoveredSubmissionError: "Si è verificato un errore durante l'invio. Riprova più tardi.",
    uncoveredSubmissionSuccess: "Grazie per aver condiviso il tuo interesse",

    // Solo FTTC pianificato (fttc_planned)
    fttcPlannedCTA: "In arrivo la rete ultraveloce",
    fttcPlannedSubTitle: "Manifesta il tuo interesse: ti aggiorneremo quando sarà disponibile.",

    // Nessuna copertura di rete (no_network)
    noNetworkCTA: "Per questo indirizzo la rete ultraveloce non è disponibile.",
    noNetworkSubTitle: "",
    noNetworkInterestLine1: "Facci sapere se sei interessato a navigare",
    noNetworkInterestLine2: "con la rete ultraveloce di FiberCop",
    noNetworkInterestButton: "Clicca qui!",




    //Uncovered fttc not planned fttc
    uncoveredFttcNotPlannedFttcCTA: "Indirizzo non coperto dalla nostra connessione",
    uncoveredFttcNotPlannedFttcFSubTitle: "",
    uncoveredRequestInfo: "Facci sapere se sei interessato a navigare con la rete ultraveloce di FiberCop",
    uncoveredSubmissionError: "Si è verificato un errore durante l'invio. Riprova più tardi.",
    uncoveredSubmissionSuccess: "Grazie per aver condiviso il tuo interesse",


     // Offers
    startingFrom: "a partire da",
    vatIncluded: "Iva Inclusa",
    details: "Dettagli",
    lessDetails: "Meno dettagli",
    discoverOffer: "Scopri l'offerta",
    validUntil: "Offerta valida fino al ",
    defaultOfferText: "Clicca e scopri subito la nostra migliore offerta",
    clickHere: "Clicca qui!",


  },
  
  en: {
    // Hero section
    heroTitleOne: "We are Italy's ",
    heroTitleTwo: "strategic digital infrastructure",
    heroTitleThree: "",
    

    // Breadcrumb
    home: "Home",
    marketspace: "Marketspace",
    
    // Common buttons and labels
    loading: "Loading...",
    error: "Error",
    retry: "Retry",
    
    // Address form
    addressTitle: "Check coverage at your address",
    addressPlaceholder: "E.g. via Roma, 1 Varese",
    searchButton: "Check coverage",
    addressNotFound: "Address not found",
    selectAddress: "Select an address",
    serviceUnavailable: "«Verify Coverage» service is currently unavailable. We apologize for the inconvenience.",
    tryAgainLater: "Please try again later.",
    closePopup: "Close popup",
    addressTooltip: "Please select an address from the detected options to continue.",


    //LoadingTruck
    loadingTruckFirstLabel: "We are verifying the coverage for your address,",
    loadingTruckSecondLabel: "this will only take a moment…",
    loadingPlaceholderTruck: "Loading...",

    // Newsletter
    newsletterTitle: "Stay updated",
    newsletterPlaceholder: "Enter your email to receive updates",
    newsletterButton: "Subscribe",
    comunePlaceholder: "City (optional)",
    privacyText: "I have read the",
    privacyLink: "Privacy Policy",
    newsletterSuccess: "Your email has been entered correctly, you will be notified as soon as possible.",
    newsletterError: "Sending error. Please try again later.",
    privacyRequired: "You must accept the privacy policy before proceeding.",
    
    
    // Pagination
    previous: "Previous",
    next: "Next",
    anotherRequest: "Make another request",

    // Disclaimer
    offersDisclaimer: "The offers published in this section are entered, updated and managed in full autonomy by the partner operators, who are solely responsible for them. FiberCop S.p.A. is a wholesale operator and does not sell connectivity services directly to the end consumer. The technology (FTTH or FTTCab) and the actual performance depend on the coverage available at the single address.",

    // Results
    covered: "Covered!",
    arriving: "Ultra-fast network coming soon",
    noCoverage: "Not yet covered",
    offersAvailable: "Available offers",

    //filters
    filterPrivate: "Residential",
    filters: "Businesses / SMEs",
    filterVelocity: "Velocity",

    //Covered
    coveredCTA: "Surf at maximum speed up to 10Gigabytes with FTTH",
    fiberstreamFtthCTA: "You can also surf at maximum speed in FTTH up to 2.5 Gigabits",
    coveredSubTitle: "Don't miss out on offers from operators for residential and business customers.",

    //Arriving
    arrivingCTA: "Surf in FTTCab up to 200 Megabytes with the best FiberCop connection available to you!",
    arrivingSubTitle: "Don't miss out on offers from operators for residential and business customers",
    buttonNotifyMe: "Notify me when available",
        //MODAL - Arriving
        titleModalArriving: "Fill in the form with your contact details, ",
        titleModalArrivingTwo: " we will notify you when your address is served by FiberCop FTTH ultra-fast network up to 10 Gigabytes",
        titleModalArrivingTwoFTTC: "we will notify you when your address is served by FiberCop FTTCab ultra-fast network up to 200 Megabytes",
        modalArrivingName: "Name",
        modalArrivingSurname: "Surname",
        modalArrivingEmail: "Email address",
        modalPrivacyCheckboxText: "I declare that I have read ",
        modalPrivacyCheckboxTextTwo: "the privacy policy",
        modalPrivacyCheckboxTextThree: " and consent to the processing of my  personal data",
        modalPrivacySubText: "Following your request your personal data will be stored  for a period not exceeding 12 months",
        modalSubmit: "Submit",

    //Uncovered ftth, but fttc
    uncoveredCTA: "Surf in FTTCab up to 200 Megabytes with the best FiberCop connection available to you!",
    uncoveredSubTitle: "Don't miss out on offers from operators for residential and business customers",
    uncoveredRequestInfo: "Let us know if you are interested in surfing with FiberCop ultra-fast network",
    uncoveredSubmissionError: "An error occurred while submitting. Please try again later.",
    uncoveredSubmissionSuccess: "Thank you for sharing your interest",

  // No network coverage (no_network)
  noNetworkTitle: "No coverage available", // non usato
  noNetworkCTA: "Ultra-fast fiber is currently not available at this address",
  noNetworkSubTitle: "",
  noNetworkInterestLine1: "Let us know if you are interested in surfing",
  noNetworkInterestLine2: "with FiberCop ultra-fast network",
  noNetworkInterestButton: "Click here!",





  // Only FTTC planned (fttc_planned)
  fttcPlannedTitle: "FTTC planned", // non usato
  fttcPlannedCTA: "Ultra-fast network coming soon",
  fttcPlannedSubTitle: "Express your interest: to receive updates on the progress of the planned coverage.",

  

    // Offers
    startingFrom: "starting from",
    vatIncluded: "VAT Included",
    details: "Details",
    lessDetails: "Less details",
    discoverOffer: "Find out more",
    validUntil: "valid until ",
    defaultOfferText: "Click and discover our best offer right away",
    clickHere: "Click here!",







  }
};

// Hook per ottenere le traduzioni
export const useTranslations = (language = 'it') => {
  return translations[language] || translations.it;
};
